import { systemEngineEnvironment } from "services/environment/systemEngine";

import {
  EngineFamily,
  WorkspaceEngine,
  WorkspaceEngineType,
} from "./engine.types";
import { startWorkspaceEngine } from "./startWorkspaceEngine";

export type CreateEngineInput = {
  engineName: string;
  type: WorkspaceEngineType;
  nodes: number;
  autoStop: string;
  initiallyStopped: boolean;
  autoStart: boolean;
  minClusters: number;
  maxClusters: number;
  family?: EngineFamily;
  releaseChannel?: string;
};

export const getEngineSqlForViewDefinition = (
  engine: CreateEngineInput | WorkspaceEngine
) => {
  // Always show START_IMMEDIATELY = false to match actual creation behavior
  // Engines are started separately via startWorkspaceEngine when needed
  let engineSql = systemEngineEnvironment.formatter.formatQuery(
    `CREATE ENGINE "${engine.engineName}" WITH
TYPE = "${engine.type}"
NODES = ?
AUTO_STOP = ?
START_IMMEDIATELY = false
AUTO_START = ?
MIN_CLUSTERS = ?
MAX_CLUSTERS = ?`,
    [
      Number(engine.nodes),
      Number(engine.autoStop),
      engine.autoStart,
      Number(engine.minClusters),
      Number(engine.maxClusters),
    ]
  );
  if ("defaultDatabase" in engine && engine.defaultDatabase) {
    engineSql += `\nDEFAULT_DATABASE = "${engine.defaultDatabase}"`;
  }
  if (engine.family) {
    engineSql += `\nFAMILY = "${engine.family}"`;
  }
  if (engine.releaseChannel) {
    engineSql += `\nRELEASE=(CHANNEL=${engine.releaseChannel})`;
  }
  return engineSql + ";";
};

export const getEngineSql = (engine: CreateEngineInput | WorkspaceEngine) => {
  // Always use START_IMMEDIATELY = false due to backend performance limitations
  // Engine is started separately via startWorkspaceEngine if needed
  let engineSql = systemEngineEnvironment.formatter.formatQuery(
    `CREATE ENGINE "${engine.engineName}" WITH
TYPE = "${engine.type}"
NODES = ?
AUTO_STOP = ?
START_IMMEDIATELY = false
AUTO_START = ?
MIN_CLUSTERS = ?
MAX_CLUSTERS = ?`,
    [
      Number(engine.nodes),
      Number(engine.autoStop),
      engine.autoStart,
      Number(engine.minClusters),
      Number(engine.maxClusters),
    ]
  );
  if ("defaultDatabase" in engine && engine.defaultDatabase) {
    engineSql += `\nDEFAULT_DATABASE = "${engine.defaultDatabase}"`;
  }
  if (engine.family) {
    engineSql += `\nFAMILY = "${engine.family}"`;
  }
  return engineSql;
};

export const createWorkspaceEngine = async (engine: CreateEngineInput) => {
  const sql = getEngineSql(engine);
  await systemEngineEnvironment.execute(sql);
  if (!engine.initiallyStopped) {
    startWorkspaceEngine(engine.engineName);
  }
};
